import { api } from "@/service";
import type {
   TApplication,
   TApplicationQueryParams,
   TApplicationWithEmis,
   TCreateApplication,
   TOverdueApplication,
} from "@/types";
import { AxiosError } from "axios";

export class ApplicationService {
   private static instance: ApplicationService;

   constructor() {
      if (ApplicationService.instance) {
         return ApplicationService.instance;
      }
      ApplicationService.instance = this;
   }

   async createApplication(slug: string, payload: TCreateApplication) {
      return api
         .post<TApplicationWithEmis>(
            `/workspaces/${slug}/applications/`,
            payload,
         )
         .then((response) => response.data)
         .catch((error: AxiosError) => {
            throw error.response?.data;
         });
   }
   async getApplications(slug: string, query?: TApplicationQueryParams) {
      return api
         .get<TApplicationWithEmis[]>(`/workspaces/${slug}/applications/`, {
            params: query,
         })
         .then((response) => response.data)
         .catch((error: AxiosError) => {
            throw error.response?.data;
         });
   }

   async getOverdueApplications(slug: string) {
      return api
         .get<TOverdueApplication[]>(`/workspaces/${slug}/applications/overdue`)
         .then((response) => response.data)
         .catch((error: AxiosError) => {
            throw error.response?.data;
         });
   }

   async getApplication(slug: string, id: number | string) {
      return api
         .get<TApplicationWithEmis>(`/workspaces/${slug}/applications/${id}`)
         .then((response) => response.data)
         .catch((error: AxiosError) => {
            throw error.response?.data;
         });
   }
   async updateApplication(
      slug: string,
      id: number | string,
      data:
         | { status: Exclude<TApplication["status"], "pending" | "approved"> }
         | { status: "approved"; date: Date },
   ) {
      return api
         .patch<void>(`/workspaces/${slug}/applications/${id}`, data)
         .then((response) => response.data)
         .catch((error: AxiosError) => {
            throw error.response?.data;
         });
   }
}
